import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type NotificationsMarkAllAsReadMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.MarkAllAsReadInput;
}>;

export type NotificationsMarkAllAsReadMutationResult = { __typename?: 'Mutation' } & {
  notificationsMarkAllAsRead?: GraphQLTypes.Maybe<
    { __typename?: 'MarkAllAsReadPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const NotificationsMarkAllAsReadDocument = /*#__PURE__*/ gql`
  mutation notificationsMarkAllAsRead($input: MarkAllAsReadInput!) {
    notificationsMarkAllAsRead(input: $input) {
      errors {
        message
      }
    }
  }
`;

/**
 * __useNotificationsMarkAllAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAllAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAllAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsMarkAllAsReadMutation, { data, loading, error }] = useNotificationsMarkAllAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationsMarkAllAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<NotificationsMarkAllAsReadMutationResult, NotificationsMarkAllAsReadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<NotificationsMarkAllAsReadMutationResult, NotificationsMarkAllAsReadMutationVariables>(
    NotificationsMarkAllAsReadDocument,
    options
  );
}
export type NotificationsMarkAllAsReadMutationHookResult = ReturnType<typeof useNotificationsMarkAllAsReadMutation>;
